"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fragmentEquals = fragmentEquals;
exports.jsonFragmentToBaseFragment = jsonFragmentToBaseFragment;
function jsonFragmentToBaseFragment(frag) {
  // @ts-ignore
  return frag;
}

/**
 * Checks whether two ABI elements are equal.
 *
 * This compares type, name and parameter types. It ignores other things that are
 * missing from incomplete data, such as from 4byte directory.
 */
function fragmentEquals(a, b) {
  var _a$inputs, _b$inputs;
  if (a.type !== b.type) {
    return false;
  }
  if (a.name !== b.name) {
    return false;
  }
  if (((_a$inputs = a.inputs) === null || _a$inputs === void 0 ? void 0 : _a$inputs.length) !== ((_b$inputs = b.inputs) === null || _b$inputs === void 0 ? void 0 : _b$inputs.length)) {
    return false;
  }
  if (a.inputs) {
    for (let i = 0; i < a.inputs.length; i++) {
      if (a.inputs[i].type !== b.inputs[i].type) {
        return false;
      }
      if (a.inputs[i].indexed !== b.inputs[i].indexed) {
        return false;
      }
    }
  }
  return true;
}
//# sourceMappingURL=DecoderData.js.map